import SmallFooter from './SmallFooter';

export default SmallFooter;
